angular.module("siter.io").factory 'State', ["$state", "$rootScope", "Auth", ($state, $rootScope, Auth) ->

  router =
    goToEditor: (siteId, pageId, reload = false) ->
      $state.go "site.page.editor", {siteId: siteId, pageId: pageId}, {reload: reload}
    goToTemplatesNew: ->
      $state.go "root.new_site"
    viewSite: ->
      url = "/sites/constructor/preview/jc_site_id/#{$rootScope.currentSite.jc_site_id || $rootScope.currentSite.slug}"
      window.open url, '_blank'
      return
    goToNotFound: ->
      $state.go "404"
    goToDashboard: ->
      $state.go "admin.dashboard.templates"
    login: ->
      Auth.isReadyLogged()
        .then ->
          router.goToDashboard()
        .catch ->
          router.goToNotFound()

  router
]



// WEBPACK FOOTER //
// ./src/app/common/services/state.service.coffee